/* eslint-disable @typescript-eslint/ban-types */
import { useState } from 'react';
import * as React from 'react';
import { PlusCircleOutlined } from '@ant-design/icons';
import {
	// Button,
	Select,
	notification,
	List,
} from 'antd';
import './sources.scss';
import ParameterSourceService from '../../../../domain/ParameterSource/ParameterSourceService';
import { getUnitsAction } from '@/redux/slices/unitsSlice';
import { getTypesAction } from '@/redux/slices/measurementsSlice';
import { connect } from 'react-redux';
import SourceCard from './Sources/SourceCard';
import { ParameterSource } from '@/domain/ParameterSource/ParameterSource';
import { Infrastructure } from '@/domain/Infrastructure/Infrastructure';
import { Parameter } from '@/domain/Infrastructure/Parameter';

import { Toggle, Button } from '@hydrodigital/design-system';

import {
	DndContext,
	KeyboardSensor,
	PointerSensor,
	closestCenter,
	useSensor,
	useSensors,
} from '@dnd-kit/core';
import {
	SortableContext,
	sortableKeyboardCoordinates,
	useSortable,
	verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import SortableItem from './SortableItem';

export interface ISourcesDetailProps {
	sources: ParameterSource[];
	parameter: Parameter | null;
	infrastructure: Infrastructure | null;
	types?: any[];
	units?: any[];
	loadUnits?: Function;
	handleLoadSources: Function;
}
export interface IParameterSource extends ParameterSource {
	isEdit: boolean;
}

const parameterSourceService = new ParameterSourceService();

function SourcesDetail({
	sources,
	parameter,
	infrastructure,
	types,
	units,
	loadUnits,
	handleLoadSources,
}: ISourcesDetailProps) {
	const newIndex = React.useRef(-1);
	const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 5,
			},
		}),
		useSensor(KeyboardSensor, {
			coordinateGetter: sortableKeyboardCoordinates,
		}),
	);

	const [sourceList, setSourceList] = useState<IParameterSource[]>(
		sources.map((source) => {
			return { ...source, isEdit: false };
		}),
	);

	const handleSortEnd = async ({ oldIndex, newIndex }: any) => {
		setSourceList((prvData: any[]) => {
			let tmpData = [...prvData];
			const moveData = tmpData.splice(oldIndex, 1);
			let newData = [...tmpData];
			newData.splice(newIndex, 0, moveData[0]);
			handleSaveCustomSources(newData);
			return newData;
		});
	};

	function replaceObjectById(array: any[], id: number, newObject: object) {
		for (let i = 0; i < array.length; i++) {
			if (array[i].id === id) {
				array[i] = newObject;
				break;
			}
		}
		return array;
	}

	async function deleteSourceById(id: any) {
		await setSourceList((previusValue) => {
			const newSources = previusValue.filter((obj) => obj.id !== id);
			parameterSourceService
				.deleteSource(sourceList.find((s) => s.id === id) as ParameterSource)
				.then(() => {
					handleLoadSources();
				});
			notification.success({
				message: 'Successful',
				description: 'Source deleted successfully',
			});
			return newSources;
		});
	}

	const handleSaveSources = async (sourceListArray?: any) => {
		if (infrastructure && parameter) {
			return await parameterSourceService.saveSourcesByInfrastructure(
				infrastructure,
				parameter,
				sourceListArray ? sourceListArray : sourceList,
			);
		}
	};

	const handleSaveCustomSources = async (newSources: IParameterSource[]) => {
		if (infrastructure && parameter) {
			const res = await parameterSourceService.saveSourcesByInfrastructure(
				infrastructure,
				parameter,
				newSources,
			);
			if (res) {
				setSourceList((previusValue) => {
					return previusValue.map((obj) => {
						return { ...obj, isEdit: false };
					});
				});
				handleLoadSources();
			}
		}
	};

	const updateSource = (source: ParameterSource) => {
		const copySources = [...sourceList];
		setSourceList([]);
		setSourceList(() => {
			return replaceObjectById(copySources, source.id, source);
		});
	};

	const updateAndSaveSource = async (source: ParameterSource) => {
		const copySources = [...sourceList];
		const updatedSources = replaceObjectById(copySources, source.id, source);

		setSourceList(updatedSources);

		try {
			await handleSaveSources(updatedSources);
			notification.success({
				message: 'Successful',
				description: 'Sources saved successfully',
			});
			newIndex.current = -1;
			handleLoadSources();
		} catch (error) {
			handleLoadSources();
		}
	};

	function handleDragEnd(event: any) {
		const { active, over, delta } = event;
		if (!over || active.id === over.id) {
			return;
		}
		if (delta.x == 0 || delta.y == 0) return;
		const oldIndex = sourceList.findIndex((s) => s.id == active.id);
		const newIndex = sourceList.findIndex((s) => s.id == over.id);
		handleSortEnd({ oldIndex, newIndex });
	}

	React.useEffect(() => {
		loadUnits && loadUnits();
	}, []);

	React.useEffect(() => {
		setSourceList(
			sources.map((source) => {
				return { ...source, isEdit: false };
			}),
		);
	}, [sources]);

	return (
		<>
			{infrastructure && (
				<div className="flex column  mt-2">
					<div
						className="grid mt-2"
						style={{ gridTemplateColumns: '1fr 1fr', padding: '0px 20px' }}
					>
						<div className="flex column">
							<span style={{ fontWeight: 800, color: '#00203C' }}>Source priority</span>
							<span>Drag card to reorder the priority of sources</span>
						</div>
						<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
							<Button
								size="small"
								label="Add new source"
								iconName="plus-circle"
								iconColor="#434B56"
								style={{
									borderColor: '#023E65',
									borderWidth: 'solid 1px',
									color: '#023E65',
									height: '40px',
									backgroundColor: '#F7F9FA',
								}}
								onClick={() => {
									setSourceList((oldvalue) => {
										return [
											...oldvalue,
											{
												id: newIndex.current,
												isEnabled: true,
												isVirtual: false,
												name: '',
												sourceSerialNumber: '',
												unitId: null,
												isEdit: true,
												deviceLatitude: infrastructure.latitude,
												deviceLongitude: infrastructure.longitude,
												sensorLatitude: infrastructure.latitude,
												sensorLongitude: infrastructure.longitude,
											} as IParameterSource,
										];
									});
								}}
							/>
							{/* 
              <Button
                shape="round"
                icon={<PlusCircleOutlined />}
                className="flex items-center ml-auto"
                style={{
                  borderColor: '#023E65',
                  color: '#023E65',
                  width: '150px',
                  height: '40px',
                }}
                disabled={sourceList.findIndex((s) => s.id == -1) >= 0}
                onClick={() => {
                  setSourceList((oldvalue) => {
                    return [
                      ...oldvalue,
                      {
                        id: newIndex.current,
                        isEnabled: true,
                        isVirtual: false,
                        name: '',
                        sourceSerialNumber: '',
                        unitId: null,
                        isEdit: true,
                      } as IParameterSource,
                    ];
                  });
                }}
              >
                Add new source
              </Button> */}
						</div>
					</div>

					{sourceList.length > 0 ? (
						<DndContext
							sensors={sensors}
							collisionDetection={closestCenter}
							onDragEnd={handleDragEnd}
						>
							<SortableContext
								items={sourceList.map((s) => s.id)}
								strategy={verticalListSortingStrategy}
							>
								<div
									className="flex column"
									style={{ overflow: 'auto', height: 'calc(100vh - 260px)' }}
								>
									{sourceList.map((source, index) => (
										<SortableItem
											index={index}
											key={source.id}
											id={source.id}
											source={source}
											infrastructure={infrastructure}
											parameter={parameter}
											sources={sources}
											updateSource={updateSource}
											deleteSourceById={deleteSourceById}
											updateAndSaveSource={updateAndSaveSource}
										/>
									))}
								</div>
							</SortableContext>
						</DndContext>
					) : (
						<div className="flex items-center justify-center" style={{ height: '200px' }}>
							<span style={{ fontSize: '16px' }}>Looks like you have nothing - yet!</span>
						</div>
					)}
				</div>
			)}
		</>
	);
}

function mapState(state: { types: { array: any }; units: { array: any } }) {
	return {
		types: state.types.array,
		units: state.units.array,
	};
}

const mapDispatch = (dispatch: any) => {
	return {
		loadUnits: () => {
			dispatch(getUnitsAction());
			dispatch(getTypesAction());
		},
	};
};

export default connect(mapState, mapDispatch)(SourcesDetail);
